export type StrataCountsType = {
  grailed: number;
  hype: number;
  sartorial: number;
  basic: number;
  core: number;
  grails: number;
};
export const allStratas =
  "(strata: 'grailed' OR strata:'basic' OR strata:'hype' OR strata:'sartorial')";
export function strataCounts(strata: {
  grailed?: number;
  hype?: number;
  basic?: number;
  core?: number;
  grails?: number;
  sartorial?: number;
}): StrataCountsType {
  return {
    grailed: (strata && strata.grailed) || 0,
    hype: (strata && strata.hype) || 0,
    sartorial: (strata && strata.sartorial) || 0,
    basic: (strata && strata.basic) || 0,
    core: (strata && strata.core) || 0,
    grails: (strata && strata.grails) || 0,
  };
}
